import type { AppDispatch } from '../store/store';
import type { Block } from '../types/Study';
import type { Vignette } from '../types/Vignette';
import type { StudyFlowEvent } from '../studyFlow';
import {
  enterStandalone,
  type StudyReturnTo,
} from '../slices/studyContext/studyContextSlice';
import { setActiveQuestionIndex } from '../slices/study/studySlice';
import { blocksCleared, blocksLoaded } from '../slices/blocks/blocksSlice';
import {
  clearVignettes,
  setVignettes,
} from '../slices/vignettes/vignettesSlice';

type StartStandaloneQbankBlockParams = {
  dispatch: AppDispatch;
  sendPhaseEvent: (event: StudyFlowEvent) => void;
  block: Block;
  vignettes?: Vignette[];
  shouldReview: boolean;
  returnTo?: Exclude<StudyReturnTo, null>;
  returnPath?: string | null;
  returnSearch?: string | null;
};

export const startStandaloneQbankBlock = ({
  dispatch,
  sendPhaseEvent,
  block,
  vignettes,
  shouldReview,
  returnTo = 'qbank-start',
  returnPath = null,
  returnSearch = null,
}: StartStandaloneQbankBlockParams) => {
  dispatch(
    enterStandalone({ blockId: block.id, returnTo, returnPath, returnSearch })
  );

  dispatch(setActiveQuestionIndex(0));
  dispatch(blocksCleared());
  dispatch(clearVignettes());
  dispatch(blocksLoaded([block]));
  dispatch(setVignettes(vignettes ?? []));

  sendPhaseEvent({
    type: shouldReview ? 'REVIEW_QBANK_BLOCK' : 'START_QBANK_BLOCK',
    blockId: block.id,
    preloaded: true,
  });
};
